import React, { useEffect, useState } from "react";

function getGooglePrivacyApi() {
  window.googlefc = window.googlefc || {};
  window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
  return window.googlefc;
}

export function reopenConsentMessage() {
  const googlefc = getGooglePrivacyApi();

  if (typeof googlefc.showRevocationMessage !== "function") {
    return false;
  }

  googlefc.showRevocationMessage();
  return true;
}

function ConsentSettingsLink({ children, className }) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const googlefc = getGooglePrivacyApi();

    googlefc.callbackQueue.push({
      CONSENT_API_READY: () => {
        if (isMounted) {
          setIsReady(true);
        }
      },
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isReady) {
    return null;
  }

  return (
    <button className={className} onClick={reopenConsentMessage} type="button">
      {children}
    </button>
  );
}

export default ConsentSettingsLink;
